<template>
  <div class="task-con">
    <div v-if="taskQueryVo.id">
      <!-- 轮播图 -->
      <assignment-con-swiper
        :img-urls="taskQueryVo.sliderImageArr"
      ></assignment-con-swiper>
      <!-- <div class="task-pictrue">
        <img :src="taskQueryVo.image" />
      </div> -->

      <!-- 任务信息描述 -->
      <div class="wrapper">
        <div class="share acea-row row-between row-bottom">
          <div class="money">
            <span class="font-color-red"> +</span>
            <span class="num font-color-red">{{ taskQueryVo.taskPrice }}</span>
          </div>
          <div class="iconfont">
            <span>完成量:&nbsp; {{ taskQueryVo.taskSales }}次</span>
          </div>
          <div
            class="iconfont icon-fenxiang"
            @click="listenerActionSheet"
          ></div>
        </div>
        <div class="introduce">{{ taskQueryVo.taskName }}</div>
        <div class="label acea-row row-between-wrapper">
          <span>申请并注册完成可获得返现金额，返现金额可作现金使用</span>
        </div>
      </div>

      <!-- 任务介绍 -->
      <div class="task-intro">
        <div class="acea-row row-center">
          <span class="title">产品介绍</span>
        </div>

        <!--
				<div class="conter" v-if="taskQueryVo.taskType === 1">
					<div class="acea-row">
						<span class="brandType">品&nbsp;&nbsp;牌</span>
						<span class="brandText">{{ taskQueryVo.brand }}</span>
					</div>
					<div class="acea-row">
						<span class="brandType">卡&nbsp;&nbsp;别</span>
						<span class="brandText">{{ taskQueryVo.brand }}</span>
					</div>
				</div>
				<div class="conter" v-if="taskQueryVo.taskType === 2">
					<div>
						<span class="brandType">名&nbsp;&nbsp;称</span>
						<span class="brandText">{{ taskQueryVo.brand }}</span>
					</div>
					<div>
						<span class="brandType">类&nbsp;&nbsp;别</span>
						<span class="brandText">{{ taskQueryVo.brand }}</span>
					</div>
				</div> -->
        <div class="conter" v-html="taskQueryVo.description"></div>
      </div>

      <!-- 操作栏 -->
      <div class="footer acea-row row-between-wrapper">
        <!-- #ifdef MP-WEIXIN -->
        <!-- <div class="item">
          <button open-type="contact" class="contacButton">
            <div style="padding-bottom: 8rpx;" class="item">
              <div class="iconfont icon-kefu"></div>
              <span>客服</span>
            </div>
          </button>
        </div> -->
        <!-- #endif -->
        <!-- <div class="item" @click="setCollect">
          <div
            class="iconfont"
            :class="
              taskQueryVo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'
            "
          ></div>
          <span>收藏</span>
        </div> -->
        <div class="item" @click="openChat">
          <div class="iconfont icon-kefu"></div>
          <div>客服</div>
        </div>
        <div class="bnt acea-row row-right">
          <div class="buy" @click="toFinish">
            <span>去完成</span>
          </div>
        </div>
      </div>
    </div>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
    <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div
        class="item"
        v-if="weixinStatus === true"
        @click="setShareInfoStatus"
      >
        <div class="iconfont icon-weixin3"></div>
        <div class="">发送给朋友</div>
      </div>
      <div class="item" v-if="weixinStatus === false" @click="shareLink">
        <div class="iconfont icon-pintuan-copy"></div>
        <div class="">复制链接</div>
      </div>
      <div class="item" @click="setPosterImageStatus">
        <div class="iconfont icon-haibao"></div>
        <div class="">生成海报</div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import StorePoster from "@components/StorePoster";
import "@assets/css/swiper.min.css";
import AssignmentConSwiper from "@components/AssignmentConSwiper";
import ShareInfo from "@components/ShareInfo";
import {
  getaAssignmentDetail,
  getTaskCollectAdd,
  getTaskCollectDel,
  toFinishTask
} from "@api/assignment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import { getTaskPoster, getShareLink } from "@api/assignment";

export default {
  name: "AssignmentIntroduce",
  components: {
    StorePoster,
    AssignmentConSwiper,
    ShareInfo
  },
  data: function() {
    return {
      weixinStatus: false,
      id: 0,
      taskQueryVo: {},
      posters: false,
      qqmapsdk: null,
      taskConClass: "task-con",
      tofinish: "",
      posterData: {
        codeBase: "",
        title: "",
        price: "",
        code: ""
      }
    };
  },
  computed: mapGetters(["isLogin", "location", "userInfo"]),
  mounted: function() {
    this.id = this.$route.params.id;
    this.tofinish = this.$route.query.toFinish;
    this.taskCon();
  },
  watch: {
    $route(n, from) {
      if (n.name !== "AssignmentList") return;
      if (from.name) this.tofinish = "";
    }
  },
  methods: {
    openChat: function() {
      // eslint-disable-next-line no-undef
      _AIHECONG("showChat");
    },
    updateTitle() {
      document.title = this.taskQueryVo.taskName || this.$route.meta.title;
    },
    //任务详情接口；
    taskCon: function() {
      let that = this;
      getaAssignmentDetail(that.id)
        .then(res => {
          that.$set(that, "taskQueryVo", res.data);
          that.updateTitle();
          console.log("this.tofinish: " + this.tofinish);
          if (this.tofinish === "toFinish") {
            toFinishTask(res.data.id).then(function() {
              window.location.href = res.data.url;
            });
          }
        })
        .catch(err => {
          that.$dialog.error(err.msg);
          that.$router.go(-1);
        })
        .finally(() => {});
    },
    //收藏任务
    setCollect: function() {
      let that = this,
        taskId = that.taskQueryVo.id,
        category = "collect";
      if (that.taskQueryVo.userCollect) {
        getTaskCollectDel(taskId, category)
          .then(function() {
            that.taskQueryVo.userCollect = !that.taskQueryVo.userCollect;
          })
          .catch(function() {
            that.$dialog.error("操作失败，请重试！");
          });
      } else {
        getTaskCollectAdd(taskId, category)
          .then(function() {
            that.taskQueryVo.userCollect = !that.taskQueryVo.userCollect;
          })
          .catch(function() {
            that.$dialog.error("操作失败，请重试！");
          });
      }
    },
    toFinish: function() {
      let url = this.taskQueryVo.url;
      if (this.userInfo.realName) {
        if (url) {
          toFinishTask(this.id).then(function() {
            window.location.href = url;
          });
        } else {
          this.$dialog.error("操作失败，请重试！");
        }
      } else {
        this.$router.push({
          path: "/user/identification",
          query: { taskId: this.taskQueryVo.id }
        });
      }
    },
    shareLink: function() {
      console.log("shareLink");
      let that = this;
      getShareLink(that.id)
        .then(res => {
          that.copyContentH5(res.data);
          this.posters = false;
          console.log(res.data);
        })
        .catch(res => {
          console.log("error");
          that.$dialog.error(res.msg);
        });
    },
    setPosterImageStatus: function() {
      let that = this;
      let data = {
        from: "h5"
      };
      getTaskPoster(that.id, data)
        .then(res => {
          that.posterData.codeBase = res.data;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function() {
      this.posters = false;
    },
    copyContentH5: function(content) {
      var input1 = document.createElement("input"); // 直接构建input
      input1.value = content; // 设置内容
      document.body.appendChild(input1);
      input1.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      console.log(input1.value);
      document.body.removeChild(input1); // 删除临时实例
    }
  }
};
</script>

<style scoped>
.task-con .task-intro .conter div {
  width: 100% !important;
}

.noscroll {
  overflow: hidden;
}

.task-con .task-pictrue img {
  width: 100%;
  height: 5rem;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
</style>
